<template>
    <div>
        <div v-if="condicionesTexto" class="condiciones m-1" v-html="condicionesTexto"></div>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
    name: 'condiciones',
    components: {
        //MenuOpcion,
    },
    data() {
        return {
            titulo: "CONDICIONES GENERALES",
            condicionesTexto: '',
        }
    },
    computed: {
        ...mapState(['auth'])
    },
    methods: {
        ...mapActions(['exec','error']),
        async cargarCondiciones() {
            // Llama a la API para obtener el texto de condiciones
            let args = { token: this.auth?.token, tipo: 1 };
            let r = await this.exec({ api: 'condiciones', arg: args });
            //console.log('Respuesta de condiciones:', r);
            if (await this.error({ r })) return;
            this.condicionesTexto = r?.datos || '***No se han podido cargar las condiciones.***';
        }
    },
    mounted() {
        this.cargarCondiciones();
    }
}
</script>